import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { Chips, ChipsModule } from 'primeng/chips';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { finalize, take } from 'rxjs';
import { TitlesInputComponent } from 'src/app/pages/admin/components/custom-data-inputs/titles-input/titles-input.component';
import { PhoneNumberInputComponent } from 'src/app/shared/components/phone-number-input/phone-number-input.component';
import { DataType } from 'src/app/shared/enums/collecting-data/data-type.enum';
import { ExternalHrefPipe } from 'src/app/shared/pipes/external-href.pipe';
import { OrgMemberCustomDataResultType, UsersService } from 'src/app/shared/services/entities/users/users.service';
import { SelectedOrgService } from 'src/app/shared/services/selected-org.service';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-custom-org-member-input',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextModule, ChipsModule, InputGroupModule, InputGroupAddonModule, InputTextareaModule,
    ExternalHrefPipe, MultiSelectModule, AutoCompleteModule, PhoneNumberInputComponent, CheckboxModule, TitlesInputComponent
  ],
  templateUrl: './custom-org-member-input.component.html',
  styleUrl: './custom-org-member-input.component.scss'
})
export class CustomOrgMemberInputComponent implements OnInit {
  DataType = DataType;

  @Input({required: true}) settingWithData: OrgMemberCustomDataResultType | undefined;
  @Input({required: true}) FC: FormControl<any> | FormGroup<any> | undefined;

  loading = false;
  lecturerTopics: string[] = [];
  filteredLecturerTopics: string[] = [];
  currentValue: string = '';

  constructor(
    public utils: UtilsService,
    private usersService: UsersService,
    private selectedOrgService: SelectedOrgService
  ) {
  }

  ngOnInit(): void {
    if (this.settingWithData?.dataType === DataType.CUSTOM_TAGS) {
      const orgId = this.selectedOrgService.getCurrentValue();
      if (!orgId) return;
      this.loading = true;
      this.usersService.getLecturerTopics({
        orgId,
        orgMemberDataUuid: this.settingWithData.uuid
      }).pipe(
        take(1),
        finalize(() => this.loading = false)
      ).subscribe((res) => {
        this.lecturerTopics = res;
        this.filteredLecturerTopics = res;
      });
    }
  }

  setAutoCompleteValue() {
    if (this.currentValue) {
      const topics = this.FC!.getRawValue() as string[] | null;
      this.FC?.setValue(topics ? [...topics, this.currentValue] : [this.currentValue]);
      this.currentValue = '';
    }
  }

  search(e: { originalEvent: Event; query: string; }) {
    this.currentValue = e.query;
    const alreadySelected = (this.FC!.getRawValue() || []) as string[];
    const alreadySelectedNormalized = alreadySelected.map((x) => x.toLowerCase().trim());
    const normalizedQuery = e.query.toLowerCase().trim();
    const filteredLecturerTopics = this.lecturerTopics.filter((topic) => topic.toLowerCase().trim().includes(normalizedQuery) && !alreadySelectedNormalized.includes(topic.toLowerCase().trim()));
    const filteredLecturerTopicsNormalized = filteredLecturerTopics.map((x) => x.trim().toLowerCase());
    if (e.query && !filteredLecturerTopicsNormalized.includes(e.query)) {
      filteredLecturerTopics.unshift(e.query);
    }
    this.filteredLecturerTopics = filteredLecturerTopics;
  }

}
